/**
 * @generated SignedSource<<9197c2cee859c6c6206532e1505b6dc9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type user_nativeIssueTable_UserCell_fieldRef$data = {
  readonly fieldId: string;
  readonly type: string;
  readonly user: {
    readonly accountId: string;
    readonly name: string;
    readonly picture: AGG$URL;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"user_nativeIssueTable_UserCellInternal_fieldRef">;
  readonly " $fragmentType": "user_nativeIssueTable_UserCell_fieldRef";
};
export type user_nativeIssueTable_UserCell_fieldRef$key = {
  readonly " $data"?: user_nativeIssueTable_UserCell_fieldRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"user_nativeIssueTable_UserCell_fieldRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcuserinlineeditrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "user_nativeIssueTable_UserCell_fieldRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        {
          "kind": "ScalarField",
          "name": "picture"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcuserinlineeditrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "isInlineEditingEnabled",
              "variableName": "isInlineEditingEnabled"
            }
          ],
          "kind": "FragmentSpread",
          "name": "user_nativeIssueTable_UserCellInternal_fieldRef"
        }
      ]
    }
  ],
  "type": "JiraSingleSelectUserPickerField"
};

(node as any).hash = "949652047f7da38438119861077ff21c";

export default node;
